import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import studygameActions from '../../store/actions/studygameActions'
import Loading from '../Loading'
import Button from '../Button'
import NewsGame from './NewsGame'
import GameButtons from './GameButtons'

const shuffler = (array) => {
    return array.sort(() => Math.random() - 0.5)
}

const GuessTitle = ({ news }) => {
    const [state, setState] = useState({
        titles: [
            { title: news.title, isRight: true }
        ],
        titlesToGet: 3,
        didAnswer: false,
        answerNumber: null
    })

    useEffect(() => {
        const newsState = state.titles
        const newsIndex = allNews.findIndex(article => article.title === news.title)
        var falseNewsIndex = [];

        //generate random unique numbers
        while (falseNewsIndex.length < state.titlesToGet) {
            var r = Math.floor(Math.random() * allNews.length - 1) + 1;
            if (falseNewsIndex.indexOf(r) === -1 && r !== newsIndex) falseNewsIndex.push(r);
        }

        falseNewsIndex.forEach((item) => {
            newsState.push({ title: allNews[item].title, isRight: false })
        })

        setState({ ...state, titles: shuffler(newsState) })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleAnswer = (answer, index) => {
        setState({
            ...state,
            didAnswer: true,
            answerNumber: index
        })

        setTimeout(() => {
            if (answer) {
                dispatch(studygameActions.finishMinigame())
            } else {
                setState({ ...state, didAnswer: false })
            }
        }, 1000)
    }

    const dispatch = useDispatch()
    const allNews = useSelector(state => state.studyGame.news)
    const isLoading = useSelector(state => state.studyGame.isLoading)
    const disabledBtn = state.didAnswer ? true : false
    const { answerNumber, titles } = state
    const newsObject = { ...news, title: 'Título desconhecido' }
    const studyGameState = useSelector(state => state.studyGame)
    const { currentRound } = studyGameState

    return (
        isLoading ? <Loading /> :
            <article className='white-container mb-4'>
                <NewsGame round={currentRound} news={newsObject} gameTitle='Advinha o título correto da notícia!' />
                <div className='grid grid-cols-1 md:grid-cols-2 gap-4 py-8 md:py-10'>
                    {titles.map((item, index) =>
                        <Button
                            key={index}
                            disabled={disabledBtn}
                            onClick={() => handleAnswer(item.isRight, index)}
                            className={`minigameButton px-6 py-4 w-full ${(disabledBtn && answerNumber === index) && item.isRight ? "btn-success" : (disabledBtn && answerNumber === index) && "btn-error"}`}
                        >
                            {item.title}
                        </Button>
                    )}
                </div>
                <GameButtons />
            </article>
    )
}

export default GuessTitle